import {
  LOAD_REPORT_DATA,
  LOAD_REPORT_DATA_SUCCESS,
  LOAD_REPORT_DATA_FAILURE,
  CLEAR_REPORT_DATA,
  LOAD_IMAGING_DATA,
  LOAD_IMAGING_DATA_SUCCESS,
  LOAD_IMAGING_DATA_FAILURE,
} from "./types";
import { displayErrorNotification } from "./notifications";
import { REPORTS_TYPES } from "../utils/const";

export const loadReportData =
  (
    downloadOrganizationDataWithRawData,
    downloadOrganizationDataWithWeekly,
    downloadOrganizationDataWithAbundance,
    downloadSpeciesLineChart,
    getOrganizationSummaryData,
    dataType,
    filters
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOAD_REPORT_DATA });
      let response = null;
      switch (dataType) {
        case REPORTS_TYPES.RAW_DATA:
          response = await downloadOrganizationDataWithRawData({ filters });
          break;
        case REPORTS_TYPES.WEEKLY_REPORT:
          response = await downloadOrganizationDataWithWeekly({ filters });
          break;
        case REPORTS_TYPES.ABUNDANCE:
          response = await downloadOrganizationDataWithAbundance({ filters });
          break;
        case REPORTS_TYPES.LINE_CHART:
          response = await downloadSpeciesLineChart({ filters });
          break;
        case REPORTS_TYPES.MONTHLY_DATA:
          response = await getOrganizationSummaryData({ filters });
          response = { data: [JSON.parse(response)] };
          break;
        case REPORTS_TYPES.PIE_CHART:
          response = await getOrganizationSummaryData({ filters });
          response = { data: [JSON.parse(response)] };
          break;
        default:
          break;
      }
      dispatch({ type: LOAD_REPORT_DATA_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: LOAD_REPORT_DATA_FAILURE });
      dispatch(displayErrorNotification(err?.message));
    }
  };

export const clearReportData = () => async (dispatch) => {
  dispatch({ type: CLEAR_REPORT_DATA });
};

export const loadImagingData = (downloadImaging) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_IMAGING_DATA });
    let response = null;
    response = await downloadImaging({});
    dispatch({ type: LOAD_IMAGING_DATA_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: LOAD_IMAGING_DATA_FAILURE });
    console.log(err?.message);
    dispatch(displayErrorNotification(err?.message));
  }
};
